var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.00004 14.6666C11.6819 14.6666 14.6667 11.6818 14.6667 7.99992C14.6667 4.31802 11.6819 1.33325 8.00004 1.33325C4.31814 1.33325 1.33337 4.31802 1.33337 7.99992C1.33337 11.6818 4.31814 14.6666 8.00004 14.6666Z",
    fill: "#3DD598"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.97625 7.45141C5.67391 7.1558 5.18687 7.15893 4.88842 7.45839C4.58997 7.75785 4.59312 8.24025 4.89546 8.53585L6.85004 10.4469C7.17159 10.7613 7.69618 10.7348 7.98375 10.3896L11.1574 6.58008C11.4277 6.25552 11.3813 5.77531 11.0536 5.5075C10.7259 5.2397 10.2411 5.2857 9.97072 5.61026L7.33234 8.7773L5.97625 7.45141Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.1be49fbe.svg";
export { ForwardRef as ReactComponent };